import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withJob } from 'react-jobs'
import { createStructuredSelector } from 'reselect'
import injectEntities from '../../../state/hoc/injectEntities'
import { bindPromiseCreators } from '../../../utils/routines'

import withUser from '../../Login/withUser'

import { withFetchProfileByIdSaga } from '../saga'
import { createFetchProfilePromise } from '../routines'
import { selectCurrentUserProfile } from '../selectors'
import { USER, USER_PUBLIC_DATA } from '../schema'

import LoadingMessage from '../../../components/LoadingMessage'

const withUserProp = withUser()
const withEntities = injectEntities({
  entities: [
    USER,
    USER_PUBLIC_DATA
  ]
})

export const mapStateToProps = createStructuredSelector({
  userProfile: selectCurrentUserProfile
})
export const mapDispatchToProps = bindPromiseCreators({
  fetch: createFetchProfilePromise
})
const connector = connect(mapStateToProps, mapDispatchToProps)

export const fetchProfileWork = ({
  fetch,
  userProfile,
  user: { id }
}) => userProfile || fetch(id)
const work = withJob({
  work: fetchProfileWork,
  LoadingComponent: () => <LoadingMessage>Recuperando perfil.</LoadingMessage>
})

export default compose(
  withEntities,
  withFetchProfileByIdSaga,
  withUserProp,
  connector,
  work
)
